import { PARTICIPATION_PALETTE } from "@/core/colors";

export const LEGEND_COLORS = {
  signups: PARTICIPATION_PALETTE.signups.solid,
  jobs_completed: PARTICIPATION_PALETTE.jobsCompleted.solid,
} as const;
